export default __webpack_public_path__ + "static/media/logo.4cf1e303.png";